<template>
  <nuxt-pwa-assets />
  <nuxt-layout>
    <nuxt-page />
  </nuxt-layout>
</template>

<script setup lang="ts">
const { setConfig } = useConfig()

await callOnce(setConfig)
</script>
